export default __webpack_public_path__ + "static/media/Group5166-1d62888b4b662af9142e3c385f423f32.f3ffa462.svg";